module.exports = __webpack_public_path__ + "img/4_14.541706ef.jpg";